window.genietheme = window.genietheme || {};

(function($){
  var $ = jQuery = $;
  var BaseURL = "https://sisterjane.com/";
  $(function() {
    
    Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

        switch (operator) {
            case '==':
                return (v1 == v2) ? options.fn(this) : options.inverse(this);
            case '===':
                return (v1 === v2) ? options.fn(this) : options.inverse(this);
            case '!=':
                return (v1 != v2) ? options.fn(this) : options.inverse(this);
            case '!==':
                return (v1 !== v2) ? options.fn(this) : options.inverse(this);
            case '<':
                return (v1 < v2) ? options.fn(this) : options.inverse(this);
            case '<=':
                return (v1 <= v2) ? options.fn(this) : options.inverse(this);
            case '>':
                return (v1 > v2) ? options.fn(this) : options.inverse(this);
            case '>=':
                return (v1 >= v2) ? options.fn(this) : options.inverse(this);
            case '&&':
                return (v1 && v2) ? options.fn(this) : options.inverse(this);
            case '||':
                return (v1 || v2) ? options.fn(this) : options.inverse(this);
            default:
                return options.inverse(this);
        }
    });
    
    Handlebars.registerHelper('times', function(n, block) {
        var accum = '';
        for(var i = 1; i <= n; ++i)
            accum += block.fn(i);
        return accum;
    });

    if($('#ajaxForm').length > 0){
      new genietheme.AjaxForm($('#ajaxForm'));
      var uploadReceipt = new genietheme.ImageUpload($('#ajaxForm'));
    }
    
    
     $('body').on('click', '.ajaxSubmit', function() {
      $(this).addClass('btn--clicked');
    });

    $('body').on('change', '#customer_payout_method', function() {
      var payout_method = $(this).val();
      $('#payout_method_detail').text($(this).find(':selected').data('detail'));
      $('#payout_method_detail').show();
      

      if(payout_method == 'paypal'){
        $('#paypal_box').show();
        $('#customer_paypal_email').attr("required","required");
      }else if(payout_method == 'gift_card'){
        $('#paypal_box').hide();
        $('#customer_paypal_email').removeAttr("required");
      }else{
        $('#payout_method_detail').hide();
        $('#paypal_box').hide();
      }
    });

    
    
    $('body').on('click', '.ajaxUpdate', function() {
      $(this).addClass('btn--clicked');
    });
    
    if($('#ProductListContainer').length > 0){
       new genietheme.ProductListDisplay();
    }

    if($('#CustomerSettingsForm').length > 0){
      new genietheme.SellerSettingsDetail();
   }
    
    //For wardrop search filter
    $('body').on('change', '#wStatus', function() {
      if($(this).val()!=''){
        $(".wgrid__item").hide();
        $("."+$(this).find(":selected").val()).show();
      }
    });
    //For admin wardrob search
    $('body').on('change', '#adminWStatus', function() {
      if($(this).val()!=''){
        new theme.adminSellerProductDisplay();
      }
    });
  });

  genietheme.config = {
     BASE_URL:'https://resell.thegenielab.com/'
  };


  genietheme.genie = {
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    temp: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType:"json",
      });
    },
    getProductForm: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType: 'json',
        crossDomain: true 
      });
    },
    getProductFormWithData: function(url,data) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        crossDomain: true 
      });
    },
    addItemsToCart: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function(params) {
      return $.ajax(params)
        .then(function(cart) {
          return cart;
        }.bind(this))
    },
    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    getUrlParams:function(){
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
          hash = hashes[i].split('=');
          vars.push(hash[0]);
          vars[hash[0]] = hash[1];
      }
      return vars;
    },
    saveForm: function(data,url) {
      return this._sendAjax({
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        crossDomain: true
      });
    },
    showNotifications: function(text,removeClass,addClass) {
      $('#notifications').removeClass(removeClass);
      $('#notifications').addClass(addClass);
      if($(text).length > 0){
        $('#notifications').text($(text).text());
      }else{
        $('#notifications').text(text);
      }
      
      $('#notifications').show();
      setTimeout(function(){
        $('#notifications').hide();
      }, 5000);
    },
    uploadReceipt: function(data,url) {
          return this._sendAjax({
              type: 'POST',
              url: url,
              data: data,
              contentType:false,
              processData:false,
              cache:false,
              dataType:"json",
          });
      },
    loadAutoComplete:function(){
      if($('#form_tags').length){
        $('#form_tags').autocomplete({
          minChars: 0,
          noCache:true,
          serviceUrl: genietheme.config.BASE_URL+'/front/browse-product/json?shop='+$('#ProductFormContainer').data('store'),
          onSelect: function (suggestion) {
            console.log(suggestion.data);
            var source = $('#tag_template').html();
            var template = Handlebars.compile(source);
            var data = {
              tag: suggestion.data,
              key: suggestion.data.replace(/ /g, "_"),
            };
            $('#selectedTags').prepend(template(data));
            $('#form_tags').val('');
          },
          onSearchComplete:function (query, suggestions) {
            if(suggestions.length == 0){
              $('.autocomplete-suggestions').html('<div class="autocomplete_new_tag" >\n' +
                  '\t      <a class="autocomplete-tag" href="javascript:void(0);" >\n' +
                  '\t      \t<svg viewBox="0 0 20 20" style="width:20px;vertical-align:bottom;"><path d="M15 10a1 1 0 0 1-1 1h-3v3a1 1 0 1 1-2 0v-3H6a1 1 0 1 1 0-2h3V6a1 1 0 0 1 2 0v3h3a1 1 0 0 1 1 1zm-5-8a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"></path></svg>\n' +
                  '\t      \t<strong >Add</strong> <span class="tag_value">'+query+'</span>\n' +
                  '\t      </a>\n' +
                  '      </div>');
              $('.autocomplete-suggestions').show();
            }
          },
          beforeRender:function(container, suggestions){
            console.log(suggestions);
            $(container).children().each(function () {
              var tag = $(this).text();
              if ( $( ".product-tag-"+tag.replace(/ /g, "_")).length > 0 ) {
                $(this).remove();
              }
            });


          }
        });
      }
    },
    wardrobeImageMarkup: function(imageSrc, aspectRatio) {
      var paddingPct = 150;
      if (aspectRatio && aspectRatio > 0) {
        paddingPct = 100 / aspectRatio;
      }
      var safeSrc = String(imageSrc).replace(/"/g, '&quot;');
      return (
        '<div class="image-wrap" style="height:0;padding-bottom:' + paddingPct + '%;">' +
        '<img class="grid-product__image lazyloaded" src="' + safeSrc + '" alt="">' +
        '</div>'
      );
    },
    getCardDataAttr: function($card, name) {
      if (!$card || !$card.length) {
        return '';
      }
      var camelKey = String(name).replace(/-([a-z])/g, function(match, letter) {
        return letter.toUpperCase();
      });
      var value = $card.data(camelKey);
      if (value !== undefined && value !== null && value !== '') {
        return value;
      }
      return $card.attr('data-' + name) || '';
    },
    buildItemDetailUrl: function(itemKey, variantId) {
      if (!itemKey) {
        return null;
      }
      var keyParts = String(itemKey).split('_');
      if (keyParts.length < 2) {
        return null;
      }
      var itemUrl = '/pages/item-detail?item=' + keyParts[0] + '-' + keyParts[1];
      if (variantId) {
        itemUrl += '-' + variantId;
      }
      return itemUrl;
    },
    setWardrobeItemLinks: function(itemKey, variantId) {
      var itemUrl = genietheme.genie.buildItemDetailUrl(itemKey, variantId);
      if (!itemUrl) {
        return;
      }
      $('#resel_' + itemKey).attr('href', itemUrl).removeAttr('disabled onclick');
      var editId = 'editproduct_' + itemKey + (variantId ? '-' + variantId : '');
      var $edit = $('#' + editId);
      if (!$edit.length) {
        $edit = $('#editproduct_' + itemKey);
      }
      if (!$edit.length) {
        $edit = $('a[id^="editproduct_' + itemKey + '"]');
      }
      if ($edit.length) {
        $edit.attr('href', itemUrl);
        if (variantId) {
          $edit.attr('id', 'editproduct_' + itemKey + '-' + variantId);
        }
      }
    },
    setWardrobeCardImage: function($card, imageSrc, aspectRatio) {
      var self = this;
      var $mask = $card.find('.wardrobe-image-mask');
      if (!imageSrc || !$mask.length) {
        return;
      }
      if (aspectRatio && aspectRatio > 0) {
        $mask.html(self.wardrobeImageMarkup(imageSrc, aspectRatio));
        return;
      }
      var probe = new Image();
      probe.onload = function() {
        var ratio = probe.naturalWidth && probe.naturalHeight
          ? probe.naturalWidth / probe.naturalHeight
          : 0.667;
        $mask.html(self.wardrobeImageMarkup(imageSrc, ratio));
      };
      probe.onerror = function() {
        $mask.html(self.wardrobeImageMarkup(imageSrc, 0.667));
      };
      probe.src = imageSrc;
    },
    applyWardrobeProductData: function($card, data) {
      if (!data) {
        return;
      }
      if (data.image_src) {
        var aspectRatio = data.aspect_ratio || data.image_aspect_ratio;
        genietheme.genie.setWardrobeCardImage($card, data.image_src, aspectRatio);
      }
      if (data.title) {
        var titleText = $('<div>').html(data.title).text();
        $card.find('.wardrobe-product-title').text(titleText);
      }
      var variantLabel = '';
      if (data.variant_options) {
        variantLabel = data.variant_options;
      } else if (data.variant_title) {
        variantLabel = data.variant_title;
      } else if (data.color || data.size) {
        variantLabel = [data.color, data.size].filter(Boolean).join(' - ');
      } else if (data.option1 || data.option2 || data.option3) {
        variantLabel = [data.option1, data.option2, data.option3].filter(Boolean).join(' - ');
      }
      if (variantLabel) {
        $card.find('.wardrobe-variant-options').text(variantLabel);
      }
      var itemKey = genietheme.genie.getCardDataAttr($card, 'item-key');
      var variantId = data.variant_id || genietheme.genie.getCardDataAttr($card, 'variant-id');
      if (variantId) {
        $card.attr('data-variant-id', variantId);
      }
      if (!itemKey) {
        var orderId = $card.attr('order-id');
        var lineScaled = genietheme.genie.getCardDataAttr($card, 'line-item-value');
        if (orderId && lineScaled) {
          itemKey = String(Number(orderId) * 100) + '_' + lineScaled;
        }
      }
      if (itemKey) {
        genietheme.genie.setWardrobeItemLinks(itemKey, variantId);
      }
    },
    applyProductStatusWardrobeData: function(data) {
      if (!data) {
        return;
      }
      for (var key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) {
          continue;
        }
        if (key.indexOf('draft_') === 0) {
          var draftItemKey = key.substring(6);
          var $draftCard = $('.wgrid__item[data-item-key="' + draftItemKey + '"]');
          if ($draftCard.length && data[key] && typeof data[key] === 'object') {
            genietheme.genie.applyWardrobeProductData($draftCard, data[key]);
          }
          continue;
        }
        if (key.indexOf('product_') !== 0 || typeof data[key] !== 'string') {
          continue;
        }
        var detailUrl = data[key];
        if (detailUrl.indexOf('/pages/item-detail') !== 0) {
          continue;
        }
        var itemMatch = detailUrl.match(/[?&]item=([^&]+)/);
        if (!itemMatch) {
          continue;
        }
        var itemParts = itemMatch[1].split('-');
        if (itemParts.length < 2) {
          continue;
        }
        var statusItemKey = itemParts[0] + '_' + itemParts[1];
        var statusVariantId = itemParts.length > 2 ? itemParts.slice(2).join('-') : '';
        genietheme.genie.setWardrobeItemLinks(statusItemKey, statusVariantId);
      }
    },
    itemDetailImageMarkup: function(imageSrc, aspectRatio) {
      var paddingPct = 150;
      if (aspectRatio && aspectRatio > 0) {
        paddingPct = 100 / aspectRatio;
      }
      var safeSrc = String(imageSrc).replace(/"/g, '&quot;');
      return (
        '<div class="product__main-photos" style="width:100%">' +
        '<div id="ProductPhotos-item_detail_image">' +
        '<div class="product-image-main product-image-main--item_detail_image">' +
        '<div class="image-wrap" style="height:0;padding-bottom:' + paddingPct + '%;">' +
        '<img class="photoswipe__image lazyloaded" src="' + safeSrc + '" alt="">' +
        '</div></div></div></div>'
      );
    },
    setItemDetailImage: function(imageSrc, aspectRatio) {
      var self = this;
      var $photos = $('#itemDetailPhotos');
      if (!imageSrc || !$photos.length) {
        return;
      }
      var render = function(ratio) {
        $photos.html(self.itemDetailImageMarkup(imageSrc, ratio || 0.667));
      };
      if (aspectRatio && aspectRatio > 0) {
        render(aspectRatio);
        return;
      }
      render(0.667);
      var probe = new Image();
      probe.onload = function() {
        if (probe.naturalWidth && probe.naturalHeight) {
          render(probe.naturalWidth / probe.naturalHeight);
        }
      };
      probe.src = imageSrc;
    },
    itemDetailNeedsCatalogFetch: function() {
      return $('#ajaxForm[data-needs-catalog-fetch]').length > 0 ||
        $('.item-detail-image-placeholder').length > 0;
    },
    itemDetailShouldFetchProductInfo: function() {
      if (!$('#getProductInfo').length) {
        return false;
      }
      if (genietheme.genie.itemDetailNeedsCatalogFetch()) {
        return true;
      }
      if ($('#ajaxForm[data-check-existing-listing]').length > 0) {
        return true;
      }
      return false;
    },
    fetchItemDetailProductInfo: function() {
      if (!genietheme.genie.itemDetailShouldFetchProductInfo()) {
        return;
      }
      var ajaxProductInfo = genietheme.config.BASE_URL + 'json/product-info?shop=' + $('body').data('store');
      var lineItemData = $('#getProductInfo').serialize();
      if (!lineItemData) {
        return;
      }
      $.LoadingOverlay('show');
      genietheme.genie.saveForm(lineItemData, ajaxProductInfo)
        .then(function(response) {
          if (!response || response.status !== true && response.status !== 'true' || !response.data) {
            return;
          }
          genietheme.genie.applyItemDetailProductData(response.data);
          genietheme.genie.applyItemDetailListingData(response.data);
        })
        .always(function() {
          $.LoadingOverlay('hide');
        })
        .fail(function() {
          console.log('item detail product-info request failed');
        });
    },
    applyItemDetailProductData: function(data) {
      if (!data) {
        return;
      }
      var needsCatalog = genietheme.genie.itemDetailNeedsCatalogFetch();
      var hasPhoto = $('#itemDetailPhotos img.photoswipe__image, #itemDetailPhotos img.lazyloaded, #itemDetailPhotos img.lazyload').filter(function() {
        var src = $(this).attr('src') || $(this).attr('data-src') || '';
        return src.indexOf('placeholder') === -1 && src.indexOf('default_') === -1;
      }).length > 0;

      if (data.image_src && (!hasPhoto || needsCatalog)) {
        var aspectRatio = data.aspect_ratio || data.image_aspect_ratio;
        genietheme.genie.setItemDetailImage(data.image_src, aspectRatio);
      }
      if (data.title && (needsCatalog || !$('.item-detail-title').text().trim())) {
        var titleText = $('<div>').html(data.title).text();
        $('.item-detail-title, .product-single__title').text(titleText);
      }
      var variantLabel = '';
      if (data.variant_options) {
        variantLabel = data.variant_options;
      } else if (data.variant_title) {
        variantLabel = data.variant_title;
      } else if (data.color || data.size) {
        variantLabel = [data.color, data.size].filter(Boolean).join(' - ');
      } else if (data.option1 || data.option2 || data.option3) {
        variantLabel = [data.option1, data.option2, data.option3].filter(Boolean).join(' - ');
      }
      if (variantLabel && (needsCatalog || !$('.item-detail-variant-options').text().trim())) {
        $('.item-detail-variant-options').text(variantLabel);
      }
      if (data.product_id) {
        $('#lineItemProductId').val(data.product_id);
      }
      if (data.variant_id) {
        $('#variantId').val(data.variant_id);
      }
    },
    applyItemDetailListingData: function(data) {
      if (!data) {
        return;
      }
      var hasListing = data.selling_price || data.front_image_name || data.back_image_name ||
        data.detail_image_name || data.describe_condition;
      if (!hasListing) {
        return;
      }
      $('.collapsible-trigger').addClass('is-open');
      $('#provide_pictures').addClass('is-open');
      if (getDevice()) {
        $('#provide_pictures').attr('style', 'height: auto;');
        $('#product_details').addClass('is-open');
        $('#product_details').attr('style', 'height: auto;');
      } else {
        $('#provide_pictures').attr('style', 'height: auto;');
        $('#product_details').addClass('is-open');
        $('#product_details').attr('style', 'height: auto;');
      }
      $('.img_div').attr('style', 'width: 200px;');
      var catalogKeys = {
        image_src: 1, title: 1, variant_options: 1, variant_title: 1,
        variant_id: 1, product_id: 1, color: 1, size: 1,
        option1: 1, option2: 1, option3: 1
      };
      for (var key in data) {
        if (catalogKeys[key] || data[key] === '') {
          continue;
        }
        if (key === 'selling_price') {
          $('#selling_price').val(parseInt(data[key], 10));
        }
        if (key === 'reject_reason' && data[key] !== '') {
          $('#reason').html('Your product has been rejected, please see your email for more information');
        }
        if (key === 'front_image_name') {
          $('#front_image_img').attr('src', data[key]);
          $('#front_image_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#front_image_name_close').show();
        }
        if (key === 'back_image_name') {
          $('#back_image_img').attr('src', data[key]);
          $('#back_image_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#back_image_name_close').show();
        }
        if (key === 'detail_image_name') {
          $('#detail_image_img').attr('src', data[key]);
          $('#detail_image_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#detail_image_name_close').show();
        }
        if (key === 'label_image_name') {
          $('#label_image_img').attr('src', data[key]);
          $('#label_image_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#label_image_name_close').show();
        }
        if (key === 'additional_image_1_name') {
          $('#additional_image_1_img').attr('src', data[key]);
          $('#additional_image_1_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#additional_image_1_name_close').show();
        }
        if (key === 'additional_image_2_name') {
          $('#additional_image_2_img').attr('src', data[key]);
          $('#additional_image_2_name').val(data[key].substring(data[key].lastIndexOf('/') + 1));
          $('#additional_image_2_name_close').show();
        }
        if (key === 'describe_condition') {
          $('#describe_condition').val(data[key]);
        }
        if (key === 'product_condition') {
          $('#condition option[value="' + data[key] + '"]').attr('selected', true);
        }
        if (key === 'gender') {
          if (data[key] === 'Men') {
            $('#gender_men').prop('checked', true);
          }
          if (data[key] === 'Women') {
            $('#gender_women').prop('checked', true);
          }
        }
        if (key === 'original_tags') {
          if (data[key] === 'yes') {
            $('#original_tags_yes').prop('checked', true);
          }
          if (data[key] === 'no') {
            $('#original_tags_no').prop('checked', true);
          }
        }
        if (key === 'signs_of_wear') {
          if (data[key] === 'yes') {
            $('#signs_of_wear_yes').prop('checked', true);
            $('#sign_wear_display').show();
          }
          if (data[key] === 'no') {
            $('#signs_of_wear_no').prop('checked', true);
            $('#sign_wear_display').hide();
          }
        }
        if (key === 'signs_list' && data[key] !== '' && data[key] != null) {
          var signsList = data[key].split(',');
          for (var i = 0; i < signsList.length; i++) {
            if (signsList[i] === 'Missin Button') {
              $('#signs_list_missing_button').prop('checked', true);
            }
            if (signsList[i] === 'Missing Embellishments') {
              $('#signs_list_missing_embellishments').prop('checked', true);
            }
            if (signsList[i] === 'Fading Or Discolouration') {
              $('#signs_list_wear_fading').prop('checked', true);
            }
            if (signsList[i] === 'Stained') {
              $('#signs_list_stains').prop('checked', true);
            }
            if (signsList[i] === 'Size Label Removed') {
              $('#signs_list_size_tag_removed').prop('checked', true);
            }
            if (signsList[i] === 'Tear or Hole') {
              $('#signs_list_minor_tear_or_hole').prop('checked', true);
            }
            if (signsList[i] === 'Tailored / Altered') {
              $('#signs_list_tailored_altered').prop('checked', true);
            }
            if (signsList[i] === 'Fabric Wear') {
              $('#signs_list_light_pilling').prop('checked', true);
            }
          }
        }
      }
    },
    fetchWardrobeDraftProducts: function() {
      var $cards = $('.wgrid__item[data-needs-draft-fetch="1"]');
      if (!$cards.length) {
        return;
      }
      var shop = $('body').data('store');
      var customerId = $('#customerSettingId').val() || '';
      var url = genietheme.config.BASE_URL + 'json/product-info?shop=' + shop;

      $cards.each(function() {
        var $card = $(this);
        var payload = {
          line_item_value: genietheme.genie.getCardDataAttr($card, 'line-item-value'),
          lineVariantId: genietheme.genie.getCardDataAttr($card, 'variant-id'),
          order_id: genietheme.genie.getCardDataAttr($card, 'order-id'),
          product_id: genietheme.genie.getCardDataAttr($card, 'product-id'),
          sku: genietheme.genie.getCardDataAttr($card, 'sku'),
          customer: customerId,
          wardrobe_key: genietheme.genie.getCardDataAttr($card, 'item-key')
        };

        genietheme.genie.saveForm(payload, url).then(function(response) {
          if (!response || (response.status !== true && response.status !== 'true') || !response.data) {
            return;
          }
          genietheme.genie.applyWardrobeProductData($card, response.data);
        }).fail(function() {
          console.log('wardrobe draft product fetch failed', genietheme.genie.getCardDataAttr($card, 'item-key'));
        });
      });
    }
   
  }

  genietheme.ImageUpload = (function() {
    var status = {
      loading: false,
      lastelementId: ''
    };

    function ImageUpload($form) {      
      this.$form = $form;
      this.$uploadBtn = this.$form.find('.multiupload');
      this.$notificationWrapper = this.$form.find('#upload_images_div_error');         
      if (this.$uploadBtn.length) {
        this.$uploadBtn.on('change', this.uploadReceipt.bind(this));
      }
    };

    ImageUpload.prototype = $.extend({}, ImageUpload.prototype, {
      uploadReceipt: function(evt, callback){   
        //console.log(evt.target.id);
        var oldSrc=document.getElementById(evt.target.id+'_img').src;
        var output = document.getElementById(evt.target.id+'_img');
        output.src = window.URL.createObjectURL(evt.target.files[0]);
        output.onload = function() {
          URL.revokeObjectURL(output.src) // free memory
        }
        
        if (status.loading && status.lastelementId == evt.target.id) {
          console.warn('already adding item to file | bail');
          return;
        }

        status.lastelementId = evt.target.id;
        status.loading = true;
        $.LoadingOverlaySetup({
            background      : "rgba(0, 0, 0, 0.5)",
            size: "50px",
        });
        $("#"+evt.target.id).parent().find('.img_div').LoadingOverlay("show");
        var form = document.getElementById(this.$form.attr('id'));
        var data = new FormData(form);
        
        var url = genietheme.config.BASE_URL+'image-upload?shop='+this.$uploadBtn.data('store');

        genietheme.genie.uploadReceipt(data,url)
            .then(function(response) {
              if(response.status){
                this.$uploadBtn.val('');
                 var baseImageUrl = genietheme.config.BASE_URL+'/images/thumb_images/';
                  var section = response.section;
                  $('#'+section+'_img').attr('src',baseImageUrl+response.image);
                  $('#'+section+'_name').val(response.image);
                  $('#'+section+'_name_close').show();
              }else{

              }

            }.bind(this))
            .always(function() {
              status.loading = false;
              $("#"+evt.target.id).parent().find('.img_div').LoadingOverlay("hide");
            }.bind(this))
        	.fail(function(xhr, status, error) {
             // $("#upload_images_div_error").html('<span style="color:red">'+xhr.responseJSON.message+'</span>');
            $('#'+evt.target.id+'_img').attr('src',oldSrc);        
            this.$notificationWrapper.notify(xhr.responseJSON.message,{ position:"top", className: "error" } );

            }.bind(this));
      },

      error: function(XMLHttpRequest) {

        console.warn(XMLHttpRequest.responseJSON.message);
        this.$notificationWrapper.notify(XMLHttpRequest.responseJSON.message,{ position:"left left", className: "error" } );

      }
    });

    return ImageUpload;
  })();
  
  genietheme.AjaxForm = (function() {
    var status = {
      loading: false
    };

    function AjaxForm($form) {
      this.$form = $form;
      this.$ajaxSubmit = $('.ajaxSubmit');
      this.$modal = $('#PolarisPortalsContainer');
      this.$notifications = $('#notificatons');

      if (this.$form.length) {
        this.$form.on('submit', this.saveForm.bind(this));
      }
    };

    AjaxForm.prototype = $.extend({}, AjaxForm.prototype, {
      saveForm: function(evt){
        evt.preventDefault();
        if(this.$ajaxSubmit.hasClass('btn--clicked')){
          // Loading indicator on add to cart button
          //this.$ajaxSubmit.addClass('Polaris-Button--loading');
          status.loading = true;
          this.$ajaxSubmit.LoadingOverlay("show");
          var data = this.$form.serialize();
          var data1 = data.split("&");
          for(var i = 0; i < data1.length; i++) {
            var data2  = data1[i].split("=");   
            if(data2['0']=='selling_price'){
              if(data2['1']==''){
               this.$ajaxSubmit.notify("Please fill the price",{ position:"top center", className: "error" });
               status.loading = false;
               this.$ajaxSubmit.LoadingOverlay("hide");
               this.$ajaxSubmit.removeClass('btn--clicked');
               return false;
              }
            }
            if(data2['0']=='front_image_name'){
              if(data2['1']==''){
               this.$ajaxSubmit.notify("Please Submit at least 4 photos",{ position:"top center", className: "error" });
               status.loading = false;
               this.$ajaxSubmit.LoadingOverlay("hide");
               this.$ajaxSubmit.removeClass('btn--clicked');
               return false;
              }
            }
            if(data2['0']=='back_image_name'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please Submit at least 4 photos",{ position:"top center", className: "error" });
                 status.loading = false;
                 this.$ajaxSubmit.LoadingOverlay("hide");
                 this.$ajaxSubmit.removeClass('btn--clicked');
                 return false; 
                }
              }
              if(data2['0']=='detail_image_name'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please Submit at least 4 photos",{ position:"top center", className: "error" });
                 status.loading = false;
                 this.$ajaxSubmit.LoadingOverlay("hide");
                 this.$ajaxSubmit.removeClass('btn--clicked');
                 return false; 
                }
              }
              if(data2['0']=='label_image_name'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please Submit at least 4 photos",{ position:"top center", className: "error" });
                 status.loading = false;
                 this.$ajaxSubmit.LoadingOverlay("hide");
                 this.$ajaxSubmit.removeClass('btn--clicked');
                 return false; 
                }
              }
              /*if(data2['0']=='additional_image_1_name'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please Submit at least 5 photos",{ position:"top center", className: "error" });
                 status.loading = false;
                 this.$ajaxSubmit.LoadingOverlay("hide");
                 this.$ajaxSubmit.removeClass('btn--clicked');
                 return false; 
                }
              }
              if(data2['0']=='additional_image_2_name'){
                if(data2['1']==''){
                 //var imageBlank=1;
                }
              }*/
              if(data2['0']=='condition'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please select condition",{ position:"top center", className: "error" });
                   status.loading = false;
                   this.$ajaxSubmit.LoadingOverlay("hide");
                   this.$ajaxSubmit.removeClass('btn--clicked');
                   return false;
                }
              }
                  console.log("Before Action");
                  if(this.$form.attr('action')=='json/item-upload' || this.$form.attr('action')=='json/admin-item-upload'){
                    console.log("After Action");
                  if($('input[name="gender_tags"]:checked').length == 0) {                
                     this.$ajaxSubmit.notify("Please select gender",{ position:"top center", className: "error" });
                     status.loading = false;
                     this.$ajaxSubmit.LoadingOverlay("hide");
                     this.$ajaxSubmit.removeClass('btn--clicked');
                     return false;                
                  }           console.log("After Action1");
                  if($('input[name="original_tags"]:checked').length == 0) {      
                   this.$ajaxSubmit.notify("Please select tags",{ position:"top center", className: "error" });
                   status.loading = false;
                   this.$ajaxSubmit.LoadingOverlay("hide");
                   this.$ajaxSubmit.removeClass('btn--clicked');
                   return false;
                  }                  
                  if($('input[name="signs_of_wear"]:checked').length == 0) {      
                      this.$ajaxSubmit.notify("Please select signs of wear",{ position:"top center", className: "error" });
                      status.loading = false;
                      this.$ajaxSubmit.LoadingOverlay("hide");
                      this.$ajaxSubmit.removeClass('btn--clicked');                  
                      return false;                
                    }else if($('input[name="signs_of_wear"]:checked').val()=='yes') {
                       if($('input[name="signs_list[]"]:checked').length == 0) {
                       this.$ajaxSubmit.notify("Please select any signs of wear",{ position:"top center", className: "error" });
                       status.loading = false;
                       this.$ajaxSubmit.LoadingOverlay("hide");
                       this.$ajaxSubmit.removeClass('btn--clicked');                  
                       return false;   
                       }                  
                    }             
                  }
              if(data2['0']=='describe_condition'){
                if(data2['1']==''){
                 this.$ajaxSubmit.notify("Please describe condition",{ position:"top center", className: "error" });
                   status.loading = false;
                   this.$ajaxSubmit.LoadingOverlay("hide");
                   this.$ajaxSubmit.removeClass('btn--clicked');
                   return false;
                }
              }
          }              
          var url = genietheme.config.BASE_URL+this.$form.attr('action')+'?shop='+$('body').data('store');
          var action = this.$form.attr('action');
          genietheme.genie.saveForm(data,url)
              .then(function(response) {
                this.success(response);
                if(response.status){
                if(response.message !='#customer_seller_check_email_text'){
                  setTimeout(function () {
                   if(url=='https://resell.thegenielab.com/json/admin-item-upload?shop=sisterjane.myshopify.com' || url=='https://resell.thegenielab.com/json/admin-seller-signup?shop=sisterjane.myshopify.com'){
                      window.location=BaseURL+"pages/admin-wardrobe";
                    }else{
                      window.location=BaseURL+"pages/my-wardrobe";
                    }
                 }, 3000);
                }
                }
              }.bind(this))
              .always(function() {
                status.loading = false;
                console.log(4);
                this.$ajaxSubmit.LoadingOverlay("hide");
                this.$ajaxSubmit.removeClass('btn--clicked');                
              }.bind(this))
              .fail(function(xhr, status, error) {
                console.log(3);
                genietheme.genie.showNotifications(xhr.responseJSON.message,'success','error');
                }.bind(this));
          
        }else{
          return;
        }



      },

      success: function(response) {
        if(response.status){  
          console.log(1);
          genietheme.genie.showNotifications(response.message,'error','success');
        }else{
          console.log(2);
          if(response.message=='#customer_seller_check_email_text'){
            genietheme.genie.showNotifications(response.message,'error','success');
          }else{
          genietheme.genie.showNotifications(response.message,'success','error');
          }
        }

      },

      error: function(XMLHttpRequest) {
        console.warn(XMLHttpRequest.responseJSON.message);
        this.$ajaxSubmit.notify(XMLHttpRequest.responseJSON.message,{ position:"top center", className: "error" });
      }
    });

    return AjaxForm;
  })();
  
  genietheme.AjaxUpdateForm = (function() {
    var status = {
      loading: false
    };

    function AjaxUpdateForm($form) {
      this.$form = $form;
      this.$ajaxSubmit = $('.ajaxUpdate');
      this.$notifications = $('.notificatons');

      if (this.$form.length) {
        this.$form.on('submit', this.saveForm.bind(this));
      }
    };

    AjaxUpdateForm.prototype = $.extend({}, AjaxUpdateForm.prototype, {
      saveForm: function(evt){
        evt.preventDefault();


        if(this.$ajaxSubmit.hasClass('btn--clicked')){


          // Loading indicator on add to cart button
          //this.$ajaxSubmit.addClass('Polaris-Button--loading');

          status.loading = true;
          this.$ajaxSubmit.LoadingOverlay("show");
			var urlParams = genietheme.genie.getUrlParams();
            var param = urlParams[0];
            if (param == 'product'){
              var product = urlParams['product'];
            }else{
              var product = 0;
            }
          var data = this.$form.serialize();

          var url = genietheme.config.BASE_URL+this.$form.attr('action')+'?shop='+$('#ProductDetailContainer').data('store')+'&customer='+$('#ProductDetailContainer').data('customer')+'&product='+product;

          genietheme.genie.saveForm(data,url)
              .then(function(response) {
                this.success(response);

              }.bind(this))
              .always(function() {
                status.loading = false;
                this.$ajaxSubmit.LoadingOverlay("hide");
                this.$ajaxSubmit.removeClass('btn--clicked');
              }.bind(this))
              .fail(function(xhr, status, error) {
                this.$ajaxSubmit.notify(xhr.responseJSON.message,{ position:"left left", className: "error" } );

                }.bind(this));
        }else{
          return;
        }



      },

      success: function(response) {
        if(response.status){

          this.$ajaxSubmit.notify(response.message,{ position:"left left", className: "success" });
            setTimeout(function(){
              window.location.href = '/pages/products';
            }, 1000);
          
        }else{
          this.$ajaxSubmit.notify(response.message,{ position:"left left", className: "error" });
        }

      },

      error: function(XMLHttpRequest) {
        console.warn(XMLHttpRequest.responseJSON.message);
        this.$ajaxSubmit.notify(XMLHttpRequest.responseJSON.message,{ position:"left left", className: "error" });
      }
    });

    return AjaxUpdateForm;
  })();
  
  genietheme.ProductListDisplay = (function() {
    var config = {
      namespace: '.productlistpage'
    };

    var selectors = {
      container: '#ProductListContainer',
      template: '#ProductListTemplate',
      type: ''
    };

    function ProductListDisplay() {
      var source = $(selectors.template).html();
      this.container = $(selectors.container);
      this.template = Handlebars.compile(source);
      var urlParams = genietheme.genie.getUrlParams();
      var page = urlParams[0];
      if(page == 'page'){
      	var pageNumber = urlParams['page'];
      }else{
      	var pageNumber = 1;
      }
      var url = genietheme.config.BASE_URL+'product/list?shop='+this.container.data('store')+'&customer='+this.container.data('customer')+'&page='+pageNumber;
       genietheme.genie.getProductForm(url).then(this.displayValues.bind(this));
      
      
      this.initEventListeners();

    };
    
     ProductListDisplay.prototype = $.extend({}, ProductListDisplay.prototype, {
      initEventListeners: function() {
     
        
      },
       displayValues: function(response) {
     		//console.log(response);
         var data = {
           products: response.products,
           productsCount: response.products.length,
           total: response.total,
           pages: response.pages
           
          };
		 $(selectors.container).append(this.template(data));
         
         new genietheme.ProductListForm($('#productListForm'));
         
          
        
      },
       

      
    });

    return ProductListDisplay;
  })();

  genietheme.SellerSettingsDetail = (function() {
    var config = {
      namespace: '.sellerdetailpage'
    };

    var selectors = {
      container: '#ajaxForm',
      type: ''
    };

    function SellerSettingsDetail() {
      this.container = $(selectors.container);
      var url = genietheme.config.BASE_URL+this.container.attr('action')+ '?shop='+$('body').data('store')+'&customer='+this.container.data('customer');
       genietheme.genie.getProductForm(url).then(this.displayValues.bind(this));
      
      
      this.initEventListeners();

    };
    
    SellerSettingsDetail.prototype = $.extend({}, SellerSettingsDetail.prototype, {
      initEventListeners: function() {
     
        
      },
       displayValues: function(response) {
     		if(response.status){
           $('#CustomerUsername').val(response.data.username);
           $('#customer_payout_method').val(response.data.payout_method);
           $('#payout_method_detail').text($('#customer_payout_method').find(':selected').data('detail'));
            $('#payout_method_detail').show();
            $('#customer_paypal_email').attr("required","required");
            if(response.data.payout_method == 'paypal'){
              $('#paypal_box').show();              
            }else if(response.data.payout_method == 'gift_card'){
              $('#paypal_box').hide();
            }else{
              $('#payout_method_detail').hide();
              $('#paypal_box').hide();
            }
           $('#customer_paypal_email').val(response.data.paypal_email);
         }
         
         
        
      },
       

      
    });

    return SellerSettingsDetail;
  }
  //for admin product     
                                     
  )();
  window.addEventListener('load', function() {
    var orderIds = [];    
    var dataAjax='';
    $(".product_sale_status").each(function() {
      if($(this).val()!='' && $(this).val()!=null && $(this).val()!="undefined"){
      	orderIds.push($(this).val());
      }
    });

    var urlParams = genietheme.genie.getUrlParams();
    if ($('#seller_type').length && urlParams && urlParams.item) {
      var orderParts = urlParams.item.split('-');
      if (orderParts.length >= 3) {
        $('#order_id').val(orderParts[0] / 100);
        $('#lineItemId').val(orderParts[1] / 100);
        $('#line_item_value').val(orderParts[1]);
        var variantFromUrl = orderParts.slice(2).join('-');
        $('#variantId').val(variantFromUrl);
        $('#lineVariantId').val(variantFromUrl);
      }
      genietheme.genie.fetchItemDetailProductInfo();
    } else if ($('#seller_type').length) {
      genietheme.genie.fetchItemDetailProductInfo();
    }else{          
    if($("#adminSellerVariantId").length && $("#adminSellerProductInfo").length){  
       var variantproductInfo =  urlParams.item.split("--");     
      var variantInfo =  variantproductInfo[1].split("-");
      $("#adminSellerVariantId").val(variantInfo[1]);
      $("#adminSellerProductInfo").val(variantInfo[0]);
      $("#admin_vproduct_id").val(variantInfo[1]);
      $("#admin_product_info").val(variantInfo[0]);
       //Get admin product info
    var ajaxAdminProductInfo = genietheme.config.BASE_URL+'json/adminseller-product-info?shop='+$('body').data('store');    
    if($("#adminSellerDetails").length && ajaxAdminProductInfo){	
	var adminPFormData = $("#getAProductInfo").serialize();
	if(adminPFormData!=''){
		$.LoadingOverlay("show"); 
		genietheme.genie.saveForm(adminPFormData,ajaxAdminProductInfo)
			.then(function(response) { 
				if(response.status==true){
                    $(".collapsible-trigger").addClass('is-open');
                    $("#provide_pictures").addClass('is-open');  
                   if(getDevice()){
                      $("#provide_pictures").attr('style',"height: auto;");
                      $("#product_details").addClass('is-open');
                      $("#product_details").attr('style',"height: auto;");
                   }else{
                      $("#provide_pictures").attr('style',"height: auto;");
                      $("#product_details").addClass('is-open');
                      $("#product_details").attr('style',"height: auto;");
                   }                   
                    $(".img_div").attr('style',"width: 200px;");
                  for (var key in response.data) {
                    console.log(key);
                    if(response.data[key]==''){
                      continue;
                    }
                    if(key=='selling_price'){
                      $("#selling_price").val(parseInt(response.data[key]));
                    }      
                     if(key=='reject_reason'){
                       if(response.data[key]!=''){
                      $("#reason").html("Your product has been rejected, please see your email for more information");
                       }
                      
                     }
                    if(key=='front_image_name'){
                      $("#front_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#front_image_name").val(filename);
                      $("#front_image_name_close").show();
                    }
                    if(key=='back_image_name'){
                      $("#back_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#back_image_name").val(filename);
                      $("#back_image_name_close").show();
                    }
                    if(key=='detail_image_name'){
                      $("#detail_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#detail_image_name").val(filename);
                      $("#detail_image_name_close").show();
                    }                    
                    if(key=='label_image_name'){
                      $("#label_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#label_image_name").val(filename);
                      $("#label_image_name_close").show();
                    }
                    if(key=='additional_image_1_name'){
                      $("#additional_image_1_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#additional_image_1_name").val(filename);
                      $("#additional_image_1_name_close").show();
                    }
                    if(key=='additional_image_2_name'){
                      $("#additional_image_2_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#additional_image_2_name").val(filename);
                      $("#additional_image_2_name_close").show();
                    }
                    if(key=='describe_condition'){
                      $("#describe_condition").val(response.data[key]);
                    }                    
                    if(key=='product_condition'){
                      $('#condition option[value="'+response.data[key]+'"]').attr("selected",true);
                    }
                    if(key=='gender'){
                      if(response.data[key]=='Men'){
                        $("#gender_men").prop('checked', true);
                      }
                     if(response.data[key]=='Women'){
                        $("#gender_women").prop('checked', true);
                      }
                    } 
                    if(key=='original_tags'){
                      if(response.data[key]=='yes'){
                        $("#original_tags_yes").prop('checked', true);
                      }
                      if(response.data[key]=='no'){
                        $("#original_tags_no").prop('checked', true);
                      }
                    } 
                    if(key=='signs_of_wear'){
                      if(response.data[key]=='yes'){
                        $("#signs_of_wear_yes").prop('checked', true);
                         $("#sign_wear_display").show(); 
                      }
                      if(response.data[key]=='no'){
                        $("#signs_of_wear_no").prop('checked', true);
                        $("#sign_wear_display").hide();                        
                      }
                    }
                    if(key=='signs_list'){
                      if(response.data[key]!=='' && response.data[key]!=null){
                      var signs_list = response.data[key].split(",");                                          
                      for (i = 0; i < signs_list.length; i++) {
                        if(signs_list[i]=='Missin Button'){
                            $("#signs_list_missing_button").prop('checked', true);
                          }
                        if(signs_list[i]=='Missing Embellishments'){
                            $("#signs_list_missing_embellishments").prop('checked', true);
                          }
                        if(signs_list[i]=='Fading Or Discolouration'){
                            $("#signs_list_wear_fading").prop('checked', true);
                          }
                        if(signs_list[i]=='Stained'){
                            $("#signs_list_stains").prop('checked', true);
                          }
                        if(signs_list[i]=='Size Label Removed'){
                            $("#signs_list_size_tag_removed").prop('checked', true);
                          }
                        if(signs_list[i]=='Tear or Hole'){
                            $("#signs_list_minor_tear_or_hole").prop('checked', true);
                          }
                        if(signs_list[i]=='Tailored / Altered'){
                            $("#signs_list_tailored_altered").prop('checked', true);
                          }
                        if(signs_list[i]=='Fabric Wear'){
                            $("#signs_list_light_pilling").prop('checked', true);
                          }
                      }
                      }
                    }
                    if(key=='product_id'){                      
                      $("#adminSellerProductId").val(response.data[key]);
                      $("#admin_product_id").val(response.data[key]);
                 }
                 if(key=='image_src'){                      
                      var imageTag = "<img class='photoswipe__image lazyautosizes lazyloaded' src='"+response.data[key]+"'/>";
                      $(".product__photos-item_detail_image").html(imageTag);                      
                 }
                 if(key=='title'){     
                      $(".product-single__title").html(response.data[key]);
                 }
                  }
				}
              if(response.status=='admin'){ 
                for (var key in response.data) {
                 if(key=='product_id'){                      
                      $("#adminSellerProductId").val(response.data[key]);
                      $("#admin_product_id").val(response.data[key]);
                 }
                 if(key=='image_src'){                      
                      var imageTag = "<img class='photoswipe__image lazyautosizes lazyloaded' src='"+response.data[key]+"'/>";
                      $(".product__photos-item_detail_image").html(imageTag);
                      $(".product-single__title").html(imageTag);
                 }
                 if(key=='title'){     
                      $(".product-single__title").html(response.data[key]);
                 }
                }
               }
			 }.bind(this))
			.always(function() {
				status.loading = false;
				$.LoadingOverlay("hide");
			}.bind(this))
			.fail(function(xhr, status, error) {
				console.log('request fail');
			}.bind(this));
		$.LoadingOverlay("hide");
	}
}
    }

    }
    
    var ajaxData = $("#orderdata").serialize();
    var AjaxUrl = genietheme.config.BASE_URL+'json/product-status?shop='+$('body').data('store');    
    if(ajaxData!=''){
      $.LoadingOverlay("show");
      genietheme.genie.saveForm(ajaxData,AjaxUrl)
      .then(function(response) {        
        if(response.status==true){
        	 for (var key in response.data) {               
             $("#order_id_"+key).html(response.data[key]);
             $("#resel_"+key).attr("href", "").attr("onClick","return false;").attr("disabled","disabled");
               if(key.search("_reason")!==-1){
                    var orgkey = key.split('_');
               		$("#resel_"+orgkey[0]).attr("title", response.data[key]);
               }
               if(response.data[key]=='Active'){
                 $(".div_"+key).removeClass("resell");
                 $(".div_"+key).addClass("pactive");
                 $(".edit_"+key).css('visibility', 'visible');  
                 $("#anc_"+key).html('<button  disabled="disabled" class="mclick btn btn--full btn--no-animate add-to-cart spo-container"><span>Active</span></button>');
               }
               if(response.data[key]=='Submitted for Approval'){
                 $(".div_"+key).removeClass("resell");
                 $(".div_"+key).addClass("pending");
                 $(".edit_"+key).css('visibility', 'visible');   
                  $("#anc_"+key).html('<button  disabled="disabled" class="mclick btn btn--full btn--no-animate add-to-cart spo-container"><span>Pending</span></button>');
               }               
               if(response.data[key]=='Sold'){
                 $(".div_"+key).removeClass("resell");
                 $(".div_"+key).addClass("sold");
                 $("#anc_"+key).html('<button  disabled="disabled" class="mclick btn btn--full btn--no-animate add-to-cart spo-container"><span>Sold</span></button>');
               }
               if(response.data[key]=='Not eligible to resell'){
                 $(".div_"+key).removeClass("resell");
                 $(".div_"+key).addClass("rejected");
                 $(".edit_"+key).css('visibility', 'visible');    
                 $("#anc_"+key).html('<button  disabled="disabled" class="mclick btn btn--full btn--no-animate add-to-cart spo-container"><span>Rejected</span></button>');
               }
         }
            genietheme.genie.applyProductStatusWardrobeData(response.data);
            $('.wgrid__item[data-item-key]').each(function() {
              var $card = $(this);
              var itemKey = genietheme.genie.getCardDataAttr($card, 'item-key');
              var variantId = genietheme.genie.getCardDataAttr($card, 'variant-id');
              if (itemKey) {
                genietheme.genie.setWardrobeItemLinks(itemKey, variantId);
              }
            });
            $("#wStatus").removeAttr("disabled");

        }
        genietheme.genie.fetchWardrobeDraftProducts();
      }.bind(this))
      .always(function() {
        status.loading = false;
        $.LoadingOverlay("hide");
      }.bind(this))
      .fail(function(xhr, status, error) {
        console.log('request fail');
        genietheme.genie.fetchWardrobeDraftProducts();
      }.bind(this));
      $.LoadingOverlay("hide");
      /*
      var saveData = $.ajax({
      type: 'POST',
      url: AjaxUrl,
      processData: false,
	  contentType: false,
      data: formData,      
      success: function(resultData) { 
         for (var key in resultData.status) {
             console.log(key);
             console.log(resultData.status[key]);
             $("#order_id_"+key).html(resultData.status[key]);
             $("#resel_"+key).attr("href", "").attr("onClick","return false;").attr("disabled","disabled");

         }
      },
      error: function (err) {
      // check the err for error details
      }
      });
      */
      $.LoadingOverlay("hide");
  } else if ($('#orderdata').length) {
    $('.wgrid__item[data-item-key]').each(function() {
      var $card = $(this);
      var itemKey = genietheme.genie.getCardDataAttr($card, 'item-key');
      var variantId = genietheme.genie.getCardDataAttr($card, 'variant-id');
      if (itemKey) {
        genietheme.genie.setWardrobeItemLinks(itemKey, variantId);
      }
    });
    if ($('.wgrid__item[data-needs-draft-fetch="1"]').length) {
      genietheme.genie.fetchWardrobeDraftProducts();
    }
  }

    //Get Customer Commission
    var customerId=$("#customerId").val();
    if(customerId!='' && customerId!=undefined){
    $.LoadingOverlay("show");
    var custFormData = new FormData();
	custFormData.append('customerId', customerId);
    var customerAjaxUrl = genietheme.config.BASE_URL+'json/customer-commission?shop='+$('body').data('store');
      $.ajax({
      type: 'POST',
      url: customerAjaxUrl,
      processData: false,
	  contentType: false,
      data: custFormData,      
      success: function(custResultData) { 
        if(custResultData.status==true){
         var myList = custResultData.data;
         if(myList!=''){console.log('123');
           buildHtmlTable('#excelDataTable',myList); 
           $("#totalBalance").text(custResultData.totalAmount);
         }else{console.log('1231');
           $("#blankText").html('Five days after the buyer receives their order, commission information will appear on this page');
         }
        }      
      },
      error: function (err) {
      // check the err for error details
      }
    });
      $.LoadingOverlay("hide");
  }

    //Get admin seller product
   /* var adminSeller=$("#admin_seller").val();
    if(adminSeller!='' && adminSeller!=undefined){
    $.LoadingOverlay("show");
    var adminFormData = new FormData();
	adminFormData.append('adminSeller', adminSeller);
    var adminAjaxUrl = genietheme.config.BASE_URL+'json/admin-seller-products?shop='+$('body').data('store');
      $.ajax({
      type: 'POST',
      url: adminAjaxUrl,
      processData: false,
	  contentType: false,
      data: adminFormData,      
      success: function(adminResultData) { 
        //$("#adminSellerData").html(adminResultData);    
      },
      error: function (err) {
      // check the err for error details
      }
    });
      $.LoadingOverlay("hide");
  }*/

   

    //Get admin product info for achive & draft
    var ajaxAdminProductInfo = genietheme.config.BASE_URL+'json/adminseller-product-info-variant?shop='+$('body').data('store');    
    
    if($("#adminAddProductPage").length && $("#adminSellerProductId").val()==''){    
    var urlParams = genietheme.genie.getUrlParams();    
    var variantproductInfo =  urlParams.item.split("--");     
    var variantInfo =  variantproductInfo[1].split("-"); 
    var customerId=$("#adminSellerDetail").val();  
    var seconds = Math.floor(Math.random()*900) + 100;  
    $("#admin_product_infov").val(variantInfo+customerId+parseInt(seconds)); 
    $("#adminSellerVariantId").val(variantInfo[0]);   
    $("#admin_vproduct_id").val(variantInfo[0]);   
	var adminPFormData = $("#getAProductInfo").serialize();
	if(adminPFormData!=''){
		$.LoadingOverlay("show"); 
		genietheme.genie.saveForm(adminPFormData,ajaxAdminProductInfo)
			.then(function(response) { 
				if(response.status==true){
                    $(".collapsible-trigger").addClass('is-open');
                    $("#provide_pictures").addClass('is-open');  
                   if(getDevice()){
                      $("#provide_pictures").attr('style',"height: auto;");
                      $("#product_details").addClass('is-open');
                      $("#product_details").attr('style',"height: auto;");
                   }else{
                      $("#provide_pictures").attr('style',"height: auto;");
                      $("#product_details").addClass('is-open');
                      $("#product_details").attr('style',"height: auto;");
                   }                   
                    $(".img_div").attr('style',"width: 200px;");
                  for (var key in response.data) {
                    console.log(key);
                    if(response.data[key]==''){
                      continue;
                    }
                    if(key=='selling_price'){
                      $("#selling_price").val(parseInt(response.data[key]));
                    }      
                     if(key=='reject_reason'){
                       if(response.data[key]!=''){
                      $("#reason").html("Your product has been rejected, please see your email for more information");
                       }
                      
                     }
                    if(key=='front_image_name'){
                      $("#front_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#front_image_name").val(filename);
                      $("#front_image_name_close").show();
                    }
                    if(key=='back_image_name'){
                      $("#back_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#back_image_name").val(filename);
                      $("#back_image_name_close").show();
                    }
                    if(key=='detail_image_name'){
                      $("#detail_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#detail_image_name").val(filename);
                      $("#detail_image_name_close").show();
                    }                    
                    if(key=='label_image_name'){
                      $("#label_image_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#label_image_name").val(filename);
                      $("#label_image_name_close").show();
                    }
                    if(key=='additional_image_1_name'){
                      $("#additional_image_1_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#additional_image_1_name").val(filename);
                      $("#additional_image_1_name_close").show();
                    }
                    if(key=='additional_image_2_name'){
                      $("#additional_image_2_img").attr("src",response.data[key]);
                      var url=response.data[key];
                      var filename = url.substring(url.lastIndexOf('/')+1);
                      $("#additional_image_2_name").val(filename);
                      $("#additional_image_2_name_close").show();
                    }
                    if(key=='describe_condition'){
                      $("#describe_condition").val(response.data[key]);
                    }                    
                    if(key=='product_condition'){
                      $('#condition option[value="'+response.data[key]+'"]').attr("selected",true);
                    }
                    if(key=='gender'){
                      if(response.data[key]=='Men'){
                        $("#gender_men").prop('checked', true);
                      }
                     if(response.data[key]=='Women'){
                        $("#gender_women").prop('checked', true);
                      }
                    } 
                    if(key=='original_tags'){
                      if(response.data[key]=='yes'){
                        $("#original_tags_yes").prop('checked', true);
                      }
                      if(response.data[key]=='no'){
                        $("#original_tags_no").prop('checked', true);
                      }
                    } 
                    if(key=='signs_of_wear'){
                      if(response.data[key]=='yes'){
                        $("#signs_of_wear_yes").prop('checked', true);
                         $("#sign_wear_display").show(); 
                      }
                      if(response.data[key]=='no'){
                        $("#signs_of_wear_no").prop('checked', true);
                        $("#sign_wear_display").hide();                        
                      }
                    }
                    if(key=='signs_list'){
                      if(response.data[key]!=='' && response.data[key]!=null){
                      var signs_list = response.data[key].split(",");                                          
                      for (i = 0; i < signs_list.length; i++) {
                        if(signs_list[i]=='Missin Button'){
                            $("#signs_list_missing_button").prop('checked', true);
                          }
                        if(signs_list[i]=='Missing Embellishments'){
                            $("#signs_list_missing_embellishments").prop('checked', true);
                          }
                        if(signs_list[i]=='Fading Or Discolouration'){
                            $("#signs_list_wear_fading").prop('checked', true);
                          }
                        if(signs_list[i]=='Stained'){
                            $("#signs_list_stains").prop('checked', true);
                          }
                        if(signs_list[i]=='Size Label Removed'){
                            $("#signs_list_size_tag_removed").prop('checked', true);
                          }
                        if(signs_list[i]=='Tear or Hole'){
                            $("#signs_list_minor_tear_or_hole").prop('checked', true);
                          }
                        if(signs_list[i]=='Tailored / Altered'){
                            $("#signs_list_tailored_altered").prop('checked', true);
                          }
                        if(signs_list[i]=='Fabric Wear'){
                            $("#signs_list_light_pilling").prop('checked', true);
                          }
                      }
                      }
                    }
                    if(key=='product_id'){                      
                      $("#adminSellerProductId").val(response.data[key]);
                      $("#admin_product_id").val(response.data[key]);
                 }
                 if(key=='image_src'){                      
                      var imageTag = "<img class='photoswipe__image lazyautosizes lazyloaded' src='"+response.data[key]+"'/>";
                       $(".product__photos").html(imageTag);
                      //$(".product-single__title").html(imageTag);
                 }
                 if(key=='title'){     
                      $(".product-single__title").html(response.data[key]);
                 }
                  }
				}
              if(response.status=='admin'){ 
                for (var key in response.data) {
                 if(key=='product_id'){                      
                      $("#adminSellerProductId").val(response.data[key]);
                      $("#admin_product_id").val(response.data[key]);
                 }
                 if(key=='image_src'){                      
                      var imageTag = "<img class='photoswipe__image lazyautosizes lazyloaded' src='"+response.data[key]+"'/>";
                      $(".product__photos").html(imageTag);
                      //$(".product-single__title").html(imageTag);
                 }
                 if(key=='title'){     
                      $(".product-single__title").html(response.data[key]);
                 }
                }
               }
			 }.bind(this))
			.always(function() {
				status.loading = false;
				$.LoadingOverlay("hide");
			}.bind(this))
			.fail(function(xhr, status, error) {
				console.log('request fail');
			}.bind(this));
		$.LoadingOverlay("hide");
	}
}
  });
////////////Product List through Handlebar


  theme.adminSellerProductDisplay = (function() {
    var config = {
      namespace: '.thankyoupage'
    };
    
    var selectors = {
      container: '#adminSellerProductContainer',
      template: '#adminSellerProductTemplate',
      type: ''
    };

    function adminSellerProductDisplay() {
     
      var source = $(selectors.template).html();
      this.template = Handlebars.compile(source);     
      var adminPCFormData = $("#customerProductData").serialize();
      console.log(adminPCFormData);
      var adminAjaxUrl = genietheme.config.BASE_URL+'json/admin-seller-products?shop='+$('body').data('store');      
      genietheme.genie.getProductFormWithData(adminAjaxUrl,adminPCFormData).then(this.displayValues.bind(this));
      this.initEventListeners();
    };
    
      adminSellerProductDisplay.prototype = $.extend({}, adminSellerProductDisplay.prototype, {
      initEventListeners: function() {
        
      },
       displayValues: function(response) {
     		console.log(response);
       var data = {           
         adminSellerProduct: response.adminSellerProduct,     
       };
         console.log(this.template(data));
         //document.getElementById('adminSellerProductContainer').innerHTML =this.template(data);
         $(selectors.container).html(this.template(data));
         //$(selectors.container).append(this.template(data));
      },     
    });

    return adminSellerProductDisplay;
  })();


// Builds the HTML Table out of myList.
function buildHtmlTable(selector, myList) {
  var columns = addAllColumnHeaders(myList, selector);
  var columnSet = [];
  for (var i = 0; i < myList.length; i++) {
    var row$ = $('<tr/>');
    row$.addClass('table__section');
      for (var key in myList[i]) {
      if ($.inArray(key, columnSet) == -1) {
        columnSet.push(key);       
      }
     }
    for (var colIndex = 0; colIndex < columns.length; colIndex++) {
      var cellValue = myList[i][columns[colIndex]];
      if (cellValue == null) cellValue = "";
      var $td=$('<td/>');
      $td.attr('data-label',columnSet[colIndex]);      
      row$.append($td.html(cellValue));
    }
    $(selector).append(row$);
  }
}

// Adds a header row to the table and returns the set of columns.
// Need to do union of keys from all records as some records may not contain
// all records.
function addAllColumnHeaders(myList, selector) {
  var columnSet = [];
  var headerTHead$ = $('<thead/>');
  var headerTr$ = $('<tr/>');
  
  for (var i = 0; i < myList.length; i++) {
    var rowHash = myList[i];
    for (var key in rowHash) {
      if ($.inArray(key, columnSet) == -1) {
        columnSet.push(key);
        headerTr$.append($('<th/>').html(key));
      }
    }
  }
  headerTHead$.append(headerTr$);
  $(selector).append(headerTHead$);

  return columnSet;
}

})(jQuery);

$(document).ready(function(){
   $("#signs_of_wear_no").click(function(){       
        $(".signCheck").prop("checked", false);
        $(".signCheck").attr('disabled', 'disabled');
        $("#sign_wear_display").hide();
        $("#product_details").attr("style","height:auto");
    }); 
    $("#signs_of_wear_yes").click(function(){       
        $(".signCheck").removeAttr('disabled', 'disabled');
        $("#sign_wear_display").show();
        $("#product_details").attr("style","height:auto");
    }); 
});
function removeProduct(productData){        
        var productFormData = new FormData();
        productFormData.append('productData', productData);
        var productAjaxUrl = genietheme.config.BASE_URL+'json/removeitem?shop='+$('body').data('store');
            $.ajax({
              type: 'POST',
              url: productAjaxUrl,
              processData: false,
              contentType: false,
              data: productFormData,      
              success: function(proResultData) { 
                if(proResultData.status==true){
                  window.location.reload();
                }      
              },
              error: function (err) {
              console.log(err);
              window.location.reload();  
              }
            });       
           
}
function removeAdminProduct(productData){        
        var productFormData = new FormData();
        productFormData.append('productData', productData);
        var productAjaxUrl = genietheme.config.BASE_URL+'json/removeadminitem?shop='+$('body').data('store');
            $.ajax({
              type: 'POST',
              url: productAjaxUrl,
              processData: false,
              contentType: false,
              data: productFormData,      
              success: function(proResultData) { 
                if(proResultData.status==true){
                  window.location.reload();
                }      
              },
              error: function (err) {
              console.log(err);
              window.location.reload();
              }
            });                  
}
function getDevice(){ 
  //return false;//navigator.userAgentData.mobile; 
  if(window.innerWidth <= 800){
    return true;
  }else{
    return false;
  }  
}
$(document).ready(function(){
   var BaseURL = "https://sisterjane.com/";
   $('#product_autoselect').autocomplete({
        appendTo: "#autocompro",
        minLength: 3,
        serviceUrl: genietheme.config.BASE_URL+'json/getallproducts',
        onSelect: function (suggestion) {
           window.location="https://sisterjane.com/pages/admin-item-details?item="+suggestion.handle+"--"+suggestion.variant_id
            $('#product_autoselect').val(suggestion.data);
            $('#productId').val(suggestion.key);  
        },
        onSearchComplete:function (query, suggestions) {
            if(suggestions.length == 0){
                //$('#product_autoselect').notify('No location found',{ position:"bottom center", className: "error",closeOverlay: false } );
            }
        }
     });
    if($('#adminSellerProductContainer').length > 0){
       new theme.adminSellerProductDisplay();
    }
    var customerID='';
    var customerSettingId='';
    if($('#adminSellerProductContainer').length > 0 || $('#adminSellerDetail').length > 0 || $('#customerSettingId').length > 0){
    if($('#adminSeller').length > 0){ 
      customerID = $('#adminSeller').val();
    }else if($('#adminSellerDetail').length > 0){
      customerID = $('#adminSellerDetail').val();
    }else if($('#customerSettingId').length > 0){
      customerID = $('#customerSettingId').val();
    }
      
    var customerAjaxUrl = genietheme.config.BASE_URL+'json/seller-detail?shop='+$('body').data('store')+'&customer='+customerID;
            $.ajax({
              type: 'GET',
              url: customerAjaxUrl,                 
              success: function(proResultData) { 
                console.log(proResultData.data.payout_method);
                if(proResultData.data.setting =='' || proResultData.data.setting ==null){
                  //$("#showWaringMsg").show();
                }else{
                  //$("#showWaringMsg").hide();
                }      
              },
              error: function (err) {
              console.log(err);
              }
            });    
    }
  
});
 function removeImage(imageSrc,hiddenInput,default_image){
  console.log('Removed'); 
  $("#"+imageSrc).attr('src',default_image);
  $("#"+hiddenInput).val('');
  $("#"+hiddenInput+"_close").hide();
}
$( document ).ready(function() {
  $('#show-poup').click(function(event) {
    event.preventDefault();   
    this.blur(); // Manually remove focus from clicked link.
    $('#condition-popup').modal();
  });
});
